import API from "@fetcher/fetcher";
import type Pagination from "@fetcher/models/IPagination";
import type IPagination from "@fetcher/models/IPagination";
import type IReferral from "@modules/clientDashboard/types/IReferral";
import type { IAPIReferral } from "@modules/clientDashboard/types/IReferral";
import { ELoadingOptions } from "@modules/loader/useLoader.hook";
import COrderStatus from "@modules/order/models/COrderStatus";
import type IOrder from "@modules/order/models/IOrder";
import type { IOrderAPI } from "@modules/order/models/IOrder";
import type { IAffiliationInformationStore } from "@store/user.store";
import dayjs from "dayjs";
import type { IClaim } from "./models/IClaim";

const BASE_URL = "/me";

export default class UserAPI {
  static getMeInformation = async () =>
    API.get<IAffiliationInformationStore>(
      BASE_URL,
      {},
      ELoadingOptions.NONE,
    ).then((res) => ({ ...res.data, lastUpdatedAt: dayjs().toISOString() }));

  static getOrders = async (page: number) => {
    return API.get<Pagination<IOrderAPI>>(
      `${BASE_URL}/orders`,
      { page },
      ELoadingOptions.NONE,
      undefined,
      true,
    ).then((res): Pagination<IOrder> => {
      return {
        meta: res.data.meta,
        data: res.data.data.map(
          (order): IOrder => ({
            ...order,
            status: new COrderStatus(order.status as unknown as string),
            purchasedAt: dayjs(order.purchasedAt),
          }),
        ),
      };
    });
  };

  static getCashbacksFromReferrals = async (page: number) => {
    return API.get<IPagination<IAPIReferral>>(
      `${BASE_URL}/referrals`,
      { page },
      ELoadingOptions.NONE,
      undefined,
      true,
    ).then((res): Pagination<IReferral> => {
      return {
        meta: res.data.meta,
        data: res.data.data.map(
          (referral): IReferral => ({
            ...referral,
            date: dayjs(referral.date),
          }),
        ),
      };
    });
  };

  static getRewardClaims = async (page: number) => {
    return API.get<IPagination<IClaim>>(
      `${BASE_URL}/claims`,
      { page },
      ELoadingOptions.MODAL,
      undefined,
      true,
    ).then((res): Pagination<IClaim> => {
      return {
        meta: res.data.meta,
        data: res.data.data.map(
          (claim): IClaim => ({
            ...claim,
            date: dayjs(claim.date),
          }),
        ),
      };
    });
  };
}
